/* eslint-disable */

import React from "react";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

export default function SecurityColumnHeaders({ columns, gridTemplateColumns }) {
  return (
    <>
      <MDTypography
        variant="body2"
        color="text"
        mb={1.5}
        sx={{ display: { xs: "block", lg: "none" }, textAlign: "left" }}
      >
        {columns.join(" · ")}
      </MDTypography>
      <MDBox
        sx={{
          display: { xs: "none", lg: "grid" },
          gridTemplateColumns,
          columnGap: 2,
          px: 2.5,
          mb: 1,
          textAlign: "left",
        }}
      >
        {columns.map((title) => (
          <MDTypography key={title} variant="body2" color="text" fontWeight="bold">
            {title}
          </MDTypography>
        ))}
      </MDBox>
    </>
  );
}
